import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { StatCard, PageHeader } from "@/components/common";
import { Building2, CreditCard, Clock, Users, BookOpen, Award, CalendarClock, GraduationCap, UserCheck } from "lucide-react";
import { Loading } from "@/pages/dashboard/Home";

export default function AdminOverview() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/admin/stats").then((r) => setS(r.data)).catch(() => {}); }, []);
  if (!s) return <Loading />;
  return (
    <div>
      <PageHeader title="Platform overview" subtitle="KOHC business health — subscriptions, funnel and delivery at a glance." />
      <div className="grid grid-cols-2 lg:grid-cols-3 gap-4">
        <StatCard testid="admin-homes" label="Care homes" value={s.care_homes} icon={Building2} />
        <StatCard testid="admin-active" label="Active subscriptions" value={s.active_subs} icon={CreditCard} tone="green" />
        <StatCard testid="admin-trials" label="Trials / founding" value={s.trials} icon={Clock} tone="coral" />
        <StatCard testid="admin-leads" label="Leads captured" value={s.leads} icon={Users} />
        <StatCard testid="admin-courses" label="Courses" value={s.courses} icon={BookOpen} />
        <StatCard testid="admin-certs" label="Certificates issued" value={s.certificates} icon={Award} tone="coral" />
        <StatCard testid="admin-sessions" label="Live sessions" value={s.sessions} icon={CalendarClock} />
        <StatCard testid="admin-tt" label="Train-the-Trainer apps" value={s.tt_applications} icon={GraduationCap} />
        <StatCard testid="admin-trainers" label="Trainers on roster" value={s.trainers} icon={UserCheck} tone="green" />
      </div>
    </div>
  );
}
